import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Button } from "react-bootstrap";
import Dropzone from "react-dropzone";

interface ImageDropzoneProps {
  onFileUpload: (file: File) => void; // Callback for file upload
  existingFile?: any; // Existing image file
  deleteHandler?: () => void; // Optional delete handler
}

const ImageDropzone: React.FC<ImageDropzoneProps> = ({
  onFileUpload,
  existingFile,
  deleteHandler,
}) => {
  const [file, setFile] = useState<any>(existingFile || null);
  const { t } = useTranslation();

  // Update file state when existingFile prop changes
  useEffect(() => {
    setFile(existingFile || null);
  }, [existingFile]);

  const handleAcceptedFiles = (acceptedFiles: File[]) => {
    const newFile = acceptedFiles[0]; // Single image upload
    const formattedFile = {
      preview: URL.createObjectURL(newFile),
      name: newFile.name,
      type: "image",
      isExisting: false,
      file: newFile,
    };
    setFile(formattedFile);
    onFileUpload(newFile);
  };

  const handleDeleteFile = () => {
    if (deleteHandler) deleteHandler();
    if (file && !file.isExisting && file.preview) {
      URL.revokeObjectURL(file.preview);
    }
    setFile(null);
  };

  return (
    <React.Fragment>
      <Dropzone onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)} multiple={false}>
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone dz-clickable text-center" {...getRootProps()}>
            <input {...getInputProps()} />
            <div className="dz-message needsclick">
              <div className="mb-3">
                <i className="display-4 text-muted ri-upload-cloud-2-fill" />
              </div>
              <p className="my-4">{t("general.dropzone.image")}</p>
            </div>
          </div>
        )}
      </Dropzone>
      {file && (
        <div className="mt-3">
          <Row className="align-items-center">
            <Col className="col-auto">
              <img
                src={file.preview}
                alt={file.name}
                className="avatar-sm rounded bg-light img-fluid"
              />
            </Col>
            {deleteHandler && (
              <Col className="col-auto">
                <Button variant="danger" size="sm" onClick={handleDeleteFile}>
                  X
                </Button>
              </Col>
            )}
          </Row>
        </div>
      )}
    </React.Fragment>
  );
};

export default ImageDropzone;